import { setHistoryFileDownloadById, setHistoryFileDownloadTimeout } from 'app/store/dcra-inspections/inspections';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';

export interface FileGeneratedProps {
  message: WebsocketMessage;
}

/**
 * For Permit Inspections History
 * @param props
 * @returns
 */
export default function InspectionFileDownloaded(props: FileGeneratedProps) {
  const { message } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (message.model.error) {
      dispatch(setHistoryFileDownloadTimeout(message.model.accela_file_id));
    } else {
      dispatch(
        setHistoryFileDownloadById(
          message.model.result.resultArr.docId,
          message.model.result.resultArr.document
        )
      );
    }
  }, [message.uuid]);

  return null;
}
